import bus from 'modules/npm-component/bus';
import container from 'modules/section-content';
import page from 'page';
import domify from 'domify';
import React from 'react';
import { render as clientRender } from 'react-dom';
import ResourceApp from './containers';
import splash from './view/main.pug';
import metadata from './metadata.json';

export default function register() {
  page('/resources', render, setRoute.bind(null, 'home'));
  page('/resources/whitepapers', render, setRoute.bind(null, 'whitepapers'));
  page('/resources/webinars', render, setRoute.bind(null, 'webinars'));
  page('/resources/ebooks', render, setRoute.bind(null, 'ebooks'));
  page('/resources/videos', render, setRoute.bind(null, 'videos'));
}

let componentWasRendered = false;
function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  if (!componentWasRendered) {
    container.render(renderOptions);
  }

  /* eslint-env browser */
  const props = window.RESOURCES_APP_STATE;

  if (!componentWasRendered) {
    clientRender(<ResourceApp {...props} />, document.querySelector('.resource-app'));
    componentWasRendered = true;
  }
  return next();
}

function setRoute(route) {
  bus.emit(`resources-page-route:${route}`);
}



// WEBPACK FOOTER //
// ./src/pages/resources/resources.js